package net.zagart.ai.core.feature.story

import net.zagart.ai.core.client.AiChatMessage

data class StoryState(
    val currentNode: StoryNode,
    val history: List<AiChatMessage>,
    val isComplete: Boolean
) {
    val narrativeText: String
        get() = when (currentNode) {
            is StoryNode.Narrative -> currentNode.text
            is StoryNode.Ending -> currentNode.text
        }

    val choices: List<StoryChoice>
        get() = when (currentNode) {
            is StoryNode.Narrative -> currentNode.choices
            is StoryNode.Ending -> emptyList()
        }
}
